import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../design-system/breakpoints';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvRecordHeaderActionsProps {
  children: ReactNode;
}

const OvRecordHeaderActions: FC<OvRecordHeaderActionsProps> = ({
  children,
}) => <Actions>{children}</Actions>;

export default OvRecordHeaderActions;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.375rem;

  button {
    min-height: 1.875rem;
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    font: inherit;
    font-size: ${Variables.fontSizes.SMALL};
    cursor: pointer;
  }

  button:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }

  button:disabled {
    cursor: default;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
    justify-content: flex-start;
  }
`;
